import { keyMirror } from 'ramda-extension';

export const textFieldFocusMode = keyMirror({
  INPUT: null,
  WHOLE: null,
});
